import DebugUANC from '../../../core/version/debug';
import { PLUGIN_NAME } from '../config';
import { loadFromLocalStorage, saveToLocalStorage } from '../../localStore';

const servicesFromWebTracker: string[] = ['pomponik.pl', 'wydarzenia.interia.pl', 'www.interia.pl', 'm.interia.pl', 'sgp2021b.interia.pl'];

/**
 * Inicjuje funkcje odpowiedzialne za zapisywanie profili użytkownika w LS
 *
 * @param {string} keyName - nazwa klucza ustawianego w LS
 * @returns {void}
 */
const setNetsprintProfileFunctions = (keyName: string): void => {
    let currentData: string[] = [];
    const setProfileData = (data: string) => {
        if (data) {
            const preparedData = data.split(',');
            currentData = [...currentData, ...preparedData];
            saveToLocalStorage(keyName, currentData);
        }
    };

    window.inpl_net_audience_bi = setProfileData;
    window.inpl_net_audience_mx = setProfileData;
    window.inpl_net_audience_cat = setProfileData;
    window.inpl_net_audience_cls = setProfileData;
    window.inpl_net_audience_int = setProfileData;
    window.inpl_net_audience_pi = setProfileData;
    window.inpl_net_audience_ef = (data) => {
        setProfileData(data);
        saveToLocalStorage('ef_' + keyName, data, false);
    };
};

/**
 * Pobiera i osadza script netsprint w document
 *
 * @param {string} host - host serwisu
 * @returns {Promise<void>}
 */
const embedNetsprintScript = async (host: string): Promise<void> => {
    return new Promise((resolve, reject) => {
        const { event } = window.Inpl.Ad;
        let body = null;
        const isExternalHost = ['polsatnews.pl', 'polsatsport.pl'].indexOf(host) !== -1;

        event?.onReady(() => {
            const script = document.createElement('script');
            script.async = true;
            script.src = `https://atm.api.dmp.nsaudience.pl/atm.js?sourceId=${isExternalHost ? host : 'interiaNew'}`;

            try {
                event?.subscribe('load', script, resolve);
                event?.subscribe('error', script, reject, 'Netsprint - error while loading iFrame');
                event?.subscribe('abort', script, reject, 'Netsprint - aborted while loading iFrame');

                if (document.body) {
                    body = document.getElementsByTagName('body')[0];
                    body.appendChild(script);
                } else {
                    event?.add('DOMContentLoaded', document, () => {
                        body = document.getElementsByTagName('body')[0];
                        body.appendChild(script);
                    });
                }
            } catch (e) {
                reject(new Error(`Problem with embedding netsprint script. ${e}`));
            }
        });
    });
};

/**
 * Inicjuje plugin NetsprintAudience.
 *
 * @returns {Promise<PLUGIN_NAME | Error>} Nazwa załadowanego pluginu lub w przypadku problemów przekazanie informacja o błędzie.
 */
export const processNetsprintAudience = async (): Promise<PLUGIN_NAME | Error> => {
    const { Ad } = window.Inpl;

    try {
        const keyNameLS = `nshost_${Ad.detection?.host}`;
        const netsprintKeywords: string[] = loadFromLocalStorage<string[]>(keyNameLS) || [];
        setNetsprintProfileFunctions(keyNameLS);

        if (Ad.detection?.host && servicesFromWebTracker.indexOf(Ad.detection.host) === -1) {
            await embedNetsprintScript(Ad.detection?.host || window.location.host);
        }

        Ad.plugins = {
            ...Ad.plugins,
            [PLUGIN_NAME.NETSPRINT]: {
                isEnabled: true,
                keywords: netsprintKeywords,
            },
        };

        if (Ad.UANC instanceof DebugUANC) {
            Ad.UANC.info(
                'Plugin NetsprintAudience',
                `has been successfully embedded. Keywords: ${netsprintKeywords.length ? netsprintKeywords : ['---']}`
            );
        }

        return PLUGIN_NAME.NETSPRINT;
    } catch (e) {
        throw new Error(`[NetsprintAudience] - problem loading the plugin. ${e}`);
    }
};
